import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=3451c6d1&scoped=true&"
var script = {}
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=3451c6d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3451c6d1",
  null
  
)

export default component.exports